/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useMemo, useContext, useState
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, DropdownSelectField } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { TranslatorContext } from '@jutro/locale';
import { Icon } from '@jutro/components';
import styles from './ScheduledArticlesComponent.module.scss';
import metadata from './ScheduledArticlesComponent.metadata.json5';


function ScheduledArticlesComponent(props) {

   const { data: scheduledArticlesTableVM, submissionVM, updateWizardData, pathUpdated, scheduledArticlesTablePath} = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);


    const addScheduledArticlesTable = useCallback(
        (event) => {
             scheduledArticlesTableVM.value = scheduledArticlesTableVM.value || []

            const { _xCenter, _dtoName } = scheduledArticlesTableVM;

            const ScheduledArticlesTableObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            ScheduledArticlesTableObjVM.isValidationReq.value = true;

            scheduledArticlesTableVM.pushElement(
                ScheduledArticlesTableObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, scheduledArticlesTableVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeScheduleArticleItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            scheduledArticlesTableVM.value.splice(index, 1);
            _.set(submissionVM.value, scheduledArticlesTablePath, scheduledArticlesTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, scheduledArticlesTablePath, scheduledArticlesTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'fie3') {
                 let ScheduleArticleArray = _.get(submissionVM, scheduledArticlesTablePath);

                 if(ScheduleArticleArray) {
                 ScheduleArticleArray = ScheduleArticleArray.value

                    const newNumber = ScheduleArticleArray?.length >= 2 ? ScheduleArticleArray[ScheduleArticleArray.length - 2].fie3 ? ScheduleArticleArray[ScheduleArticleArray.length - 2].fie3 + 1 : 1 : index + 1;

                    if (ScheduleArticleArray[index].fie3 === undefined) {
                        ScheduleArticleArray[index].fie3 = newNumber;
                        _.set(submissionVM.value, scheduledArticlesTablePath, scheduledArticlesTableVM.value);
                    } 
                 }
                

                const value = index + 1;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'desofArtFie') {
                const value = item[path] ? item[path] : '';
                const disabled = false;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        disabled={disabled}
                        value={value}
                    />
                );
            }

            if (path === 'typofArtFie') {
            
                 
                const availableValues = scheduledArticlesTableVM.length > 0 && scheduledArticlesTableVM.children[index].typofArtFie
                     
                    ? scheduledArticlesTableVM.children[index].typofArtFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                const value = item[path] ? item[path] : null;

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'valFie') {
                const value = item[path] ? item[path] : '';
                

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item[path] = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }  

           
        }, [scheduledArticlesTablePath, scheduledArticlesTableVM?.value, handleValueChange, submissionVM?.value])

    const removeScheduledArticlesTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeScheduleArticleItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeScheduleArticleItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`scheduledArticlesTable`]: {
            data: scheduledArticlesTableVM.value
        }

    }), [scheduledArticlesTableVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addScheduledArticlesTable,
            getTableCell,
            removeScheduledArticlesTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            scheduledArticlesTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [scheduledArticlesTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={scheduledArticlesTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ScheduledArticlesComponent.propTypes = wizardProps;
export default withRouter(ScheduledArticlesComponent);
